import React from 'react';
import { ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap';
import EmployeesSelected from './EmployeesSelected.jsx';
import EmployeesAutocomplete from '../employees-autocomplete/EmployeesAutocomplete.jsx';

const EmployeesFormField = (props) => {
  const {
    name,
    meta,
    selected,
    handleSelect,
    additionalSearchParams,
    title,
    isItemActive,
    addBtn,
    multiple = true,
  } = props;
  const hasError = meta && meta.touched && (meta.error || meta.submitError);
  return (
    <React.Fragment>
      <FormGroup validationState={hasError ? 'error' : null} className="m-b-8">
        <ControlLabel className="flex flex-justify">
          <div>
            {title}
            {multiple ? (
              <strong className="bordered bordered-xs text-muted m-l-8">
                Total:&nbsp;
                <span className="text-info-brand count">{selected.length}</span>
              </strong>
            ) : null}
          </div>
          {addBtn}
        </ControlLabel>
        <EmployeesAutocomplete
          isItemActive={isItemActive}
          handleSelect={handleSelect}
          additionalSearchParams={additionalSearchParams}
        />
        {hasError && <HelpBlock>{meta.error || meta.submitError}</HelpBlock>}
      </FormGroup>
      {selected.length > 0 ? (
        <div className="m-t-8">
          <EmployeesSelected
            selected={selected}
            handleSelect={(val) => handleSelect(val, true)}
            name={name}
          />
        </div>
      ) : null}
    </React.Fragment>
  );
};
export default EmployeesFormField;
